import { AuditLogTab } from '../components/AuditLogTab';

export function AuditSection() {
  return <AuditLogTab />;
}
